import React, { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";
import moment from "moment";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CSVExport from "../../../components/csvExport";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import CustomTable from "../../../components/table/table";
import {
  adminInternshipRequestsList,
  superadminInternshipRequestsList,
  internshipQualifications,
} from "../admin.api";
import "./style.css";
import * as XLSX from "xlsx";

const getStatusInfo = (status) => {
  const statusMap = {
    pending: {
      label: "Pending",
      class: "pending",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      )
    },
    submitted_for_acceptance: {
      label: "Submitted",
      class: "info",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
        </svg>
      )
    },
    approved: {
      label: "Approved",
      class: "successs",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      )
    },
    rejected: {
      label: "Rejected",
      class: "danger",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
      )
    },
    initially_rejected: {
      label: "Admin Rejected",
      class: "danger",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M12 8v4m0 4h.01"></path>
        </svg>
      )
    },
  };
  const defaultIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="16" x2="12" y2="12"></line>
      <line x1="12" y1="8" x2="12.01" y2="8"></line>
    </svg>
  );
  return statusMap[status] || {
    label: status?.charAt(0).toUpperCase() + status?.slice(1),
    class: "secondary",
    icon: defaultIcon
  };
};

export default function InternshipRequestsList(props) {
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [qualificationTypes, setQualificationTypes] = useState([]);
  const [qualificationsList, setQualificationsList] = useState([]);
  const [streamsList, setStreamsList] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    qualification_type: "",
    qualifications: "",
    streams: "",
    status: "",
  });

  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const fetchQualifications = () => {
    internshipQualifications().then((res) => {
      if (res?.data) {
        setQualificationTypes(res.data);
      }
    });
  };

  const fetchInternshipRequests = () => {
    setIsActive(true);
    const apiCall =
      adminType === 2
        ? superadminInternshipRequestsList(page, perPage, filters)
        : adminInternshipRequestsList(page, perPage, filters);

    apiCall
      .then((res) => {
        if (res?.success) {
          let tdata = res.data || [];
          tdata.forEach((item, index) => {
            item["slno"] = (page - 1) * perPage + index + 1;
          });
          setData(tdata);
          setTotalPages(res.pagination?.last_page || 1);
        }
        setIsActive(false);
      })
      .catch((error) => {
        console.error("Error fetching internship requests:", error);
        setSnackMessage("Failed to load internship requests");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  useEffect(() => {
    fetchQualifications();
  }, []);

  useEffect(() => {
    fetchInternshipRequests();
  }, [page, perPage, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };

    if (name === "qualification_type") {
      newFilters.qualifications = "";
      newFilters.streams = "";
      const selectedType = qualificationTypes.find((q) => q.id == value);
      setQualificationsList(selectedType ? selectedType.children_recursive : []);
      setStreamsList([]);
    } else if (name === "qualifications") {
      newFilters.streams = "";
      const selectedQual = qualificationsList.find((q) => q.id == value);
      setStreamsList(selectedQual ? selectedQual.children_recursive : []);
    }

    setFilters(newFilters);
    setPage(1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(parseInt(e.target.value));
    setPage(1);
  };

  const renderPagination = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, page - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);

    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }

    if (start > 1) {
      pages.push(
        <button key={1} className="btn btn-sm btn-outline-primary" onClick={() => setPage(1)}>1</button>
      );
      if (start > 2) pages.push(<span key="start-dots" className="px-1 text-primary">...</span>);
    }

    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm ${page === i ? "btn-primary text-white" : "btn-outline-primary"}`}
          onClick={() => setPage(i)}
        >
          {i}
        </button>
      );
    }

    if (end < totalPages) {
      if (end < totalPages - 1) pages.push(<span key="end-dots" className="px-1 text-primary">...</span>);
      pages.push(
        <button key={totalPages} className="btn btn-sm btn-outline-primary" onClick={() => setPage(totalPages)}>{totalPages}</button>
      );
    }

    return pages;
  };

  const handleView = (row) => {
    let path = `/admin-internship-requests/${row.id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };

  const handleDeleteConfirm = (data) => {
    // Delete functionality can be added later when API is available
    setOpenAction(false);
    setSnackMessage("Delete functionality coming soon");
    setIsSnackError(false);
    setSnackOpen(true);
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      fetchInternshipRequests();
    }
  };

  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item, index) => {
      exportdata.push({
        "Sl No": index + 1,
        "Company Name": item.company?.company_name || "--",
        Discipline: item.internship_discipline || "--",
        Description: item.brief_description || "--",
        "No. of Positions": item.number_of_students || "--",
        "Start Date": item.preferred_start_date
          ? moment(item.preferred_start_date).format("DD-MMM-YYYY")
          : "--",
        "End Date": item.preferred_end_date
          ? moment(item.preferred_end_date).format("DD-MMM-YYYY")
          : "--",
        "Grade Criteria": item.grade_criteria || "--",
        "Certifications Required": item.additional_certifications || "--",
        Status: getStatusInfo(item.status).label,
        "Submitted Date": item.created_at
          ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A")
          : "--",
      });
    });
    return exportdata;
  }

  const downloadExcel = async () => {
    const exportData = await fetchExportData();

    if (!exportData.length) {
      setSnackMessage("No data available to download.");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Internship Requests");

    XLSX.writeFile(workbook, "Internship_Requests.xlsx");
  };

  return (
    <div className="container-fluid mt-4">
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="card shadow-sm">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="mb-0"><b>Internship Requests</b></h5>
          <div className="d-flex gap-2">
            <button className="btn btn-primary btn-sm" onClick={downloadExcel}>
              Download Excel
            </button>
            <button
              className={`filter-icon-btn ${showFilters ? "active" : ""}`}
              onClick={() => setShowFilters(!showFilters)}
              title="Toggle Filters"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
              </svg>
            </button>
          </div>
        </div>

        <div className="card-body pt-0">
          <div className={`filter-container ${showFilters ? "show" : ""}`}>
            <div className="row align-items-end">
              <div className="col-md-2">
                <label className="form-label small">Type</label>
                <select
                  name="qualification_type"
                  className="form-control filter-select"
                  value={filters.qualification_type}
                  onChange={handleFilterChange}
                >
                  <option value="">All Types</option>
                  {qualificationTypes.map((q) => (
                    <option key={q.id} value={q.id}>{q.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label small">Qualifications</label>
                <select
                  name="qualifications"
                  className="form-control filter-select"
                  value={filters.qualifications}
                  onChange={handleFilterChange}
                  disabled={!filters.qualification_type}
                >
                  <option value="">All Qualifications</option>
                  {qualificationsList.map((q) => (
                    <option key={q.id} value={q.id}>{q.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label small">Stream</label>
                <select
                  name="streams"
                  className="form-control filter-select"
                  value={filters.streams}
                  onChange={handleFilterChange}
                  disabled={!filters.qualifications}
                >
                  <option value="">All Streams</option>
                  {streamsList.map((q) => (
                    <option key={q.id} value={q.id}>{q.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <label className="form-label small">Status</label>
                <select
                  name="status"
                  className="form-control filter-select"
                  value={filters.status}
                  onChange={handleFilterChange}
                >
                  <option value="">All Statuses</option>
                  <option value="pending">Pending</option>
                  <option value="submitted_for_acceptance">Submitted</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                  <option value="initially_rejected">Admin Rejected</option>
                </select>
              </div>
              <div className="col-md-2 d-flex gap-2">
                <button
                  className="filter-action-btn"
                  title="Reset Filters"
                  onClick={() => {
                    setFilters({
                      qualification_type: "",
                      qualifications: "",
                      streams: "",
                      status: "",
                    });
                    setQualificationsList([]);
                    setStreamsList([]);
                    setPage(1);
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                    <path d="M3 3v5h5"></path>
                  </svg>
                </button>
                <button
                  className="filter-action-btn close-btn"
                  title="Close Filters"
                  onClick={() => setShowFilters(false)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <CustomTable
            {...props}
            columns={[
              {
                title: "Company",
                field: "company",
                render: (row) => row.company?.company_name || "--",
              },
              { title: "Discipline", field: "internship_discipline" },
              { title: "No. of Positions", field: "number_of_students" },
              {
                title: "Start Date",
                field: "preferred_start_date",
                render: (row) => row.preferred_start_date ? moment(row.preferred_start_date).format("DD-MMM-YYYY") : "--",
              },
              {
                title: "End Date",
                field: "preferred_end_date",
                render: (row) => row.preferred_end_date ? moment(row.preferred_end_date).format("DD-MMM-YYYY") : "--",
              },
              {
                title: "Status",
                field: "status",
                render: (row) => {
                  const statusInfo = getStatusInfo(row.status);
                  return (
                    <span className={`status-badge ${statusInfo.class}`}>
                      <span className="status-icon">{statusInfo.icon}</span>
                      <span className="status-label">{statusInfo.label}</span>
                    </span>
                  );
                },
              },
              {
                title: "Action",
                render: (row) => (
                  <div className="d-flex gap-1">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => handleView(row)}
                    >
                      View
                    </button>
                  </div>
                ),
              },
            ]}
            data={data}
            paging={false}
            options={{
              search: true,
              selection: false,
              exportButton: false,
            }}
          />

          <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="flex-grow-1"></div>
            <div className="btn-group">
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
              >
                Prev
              </button>
              {renderPagination()}
              <button
                className="btn btn-sm btn-outline-primary"
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Next
              </button>
            </div>
            <div className="flex-grow-1 d-flex justify-content-end">
              <select
                className="form-control form-control-sm w-auto ml-2"
                value={perPage}
                onChange={handlePerPageChange}
                style={{ fontSize: "8px", height: "31px" }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
              </select>
            </div>
          </div>
        </div>
        {openAction && (
          <ConfirmDialog
            open={openAction}
            title="Delete Internship Request?"
            data={activeData}
            message="Are you sure you want to delete this internship request?"
            secondary_action="Cancel"
            primary_action="Delete"
            handleClose={handleCancelDelete}
            handleConfirm={handleDeleteConfirm}
          />
        )}
      </div>
    </div>
  );
}
